import { z } from "zod";
import { BaseModelFields } from "./base-model";

export type MessageTemplateCategory =
  | "General"
  | "Welcome"
  | "Order"
  | "Shipping"
  | "FollowUp";

export interface MessageTemplate extends BaseModelFields {
  key: string;
  name: string;
  category: string;
  content: string;
  isActive: boolean;
}

// Request/Response DTOs (single source of truth for API contracts)
export interface MessageTemplateCreateRequest {
  key: string;
  name: string;
  category: string;
  content: string;
  isActive?: boolean;
}

export interface MessageTemplateUpdateRequest {
  key?: string;
  name?: string;
  category?: string;
  content?: string;
  isActive?: boolean;
}

// Message template form schema for create operations
export const messageTemplateCreateSchema = z.object({
  key: z.string().min(1, "Key is required"),
  name: z.string().min(1, "Name is required"),
  category: z.string().min(1, "Category is required"),
  content: z.string().min(1, "Content is required"),
  isActive: z.boolean().optional(),
});

// Message template form schema for update operations
export const messageTemplateUpdateSchema = z.object({
  key: z.string().min(1, "Key is required").optional(),
  name: z.string().min(1, "Name is required").optional(),
  category: z.string().min(1, "Category is required").optional(),
  content: z.string().min(1, "Content is required").optional(),
  isActive: z.boolean().optional(),
});

// Message template form values types
export type MessageTemplateCreateFormValues = z.infer<
  typeof messageTemplateCreateSchema
>;
export type MessageTemplateUpdateFormValues = z.infer<
  typeof messageTemplateUpdateSchema
>;
